import { c as _c } from "react/compiler-runtime";
import type { OnboardingStatus } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useStatusText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "entityStatuses"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = status => {
      if (status === "pass") {
        return t(_temp);
      }
      if (status === "fail") {
        return t(_temp2);
      }
      if (status === "none") {
        return t(_temp3);
      }
      if (status === "incomplete") {
        return t(_temp4);
      }
      if (status === "pending") {
        return t(_temp5);
      }
      if (status === "error") {
        return t(_temp6);
      }
      return "-";
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useStatusText;
function _temp($) {
  return $.pass;
}
function _temp2($_0) {
  return $_0.fail;
}
function _temp3($_1) {
  return $_1.none;
}
function _temp4($_2) {
  return $_2.incomplete;
}
function _temp5($_3) {
  return $_3.pending;
}
function _temp6($_4) {
  return $_4.error;
}